import { signal } from '@lit-labs/signals';
export const isLoggedIn = signal(true);
//# sourceMappingURL=df-upload-link-auth.js.map